(() => {
  angular
    .module('app.core')
    .factory('EventsService', eventsService);

    eventsService.$inject = ['$resource'];

    function eventsService() {
      const allowedEventTypes = [{
        cssClass: 'impression',
        name: 'Impressions',
        labelName: 'Impression',
        type: 'impression',
        color: '#16D6D8'
      }, {
        cssClass: 'iv-supported',
        name: 'In-View supported events',
        labelName: 'In-View supported',
        type: 'iv-supported',
        color: '#9EE00F'
      }, {
        cssClass: 'iv-inview',
        name: 'In-View events',
        labelName: 'In-View',
        type: 'iv-inview',
        color: '#9EE00F'
      }, {
        cssClass: 'videostart',
        name: 'Video Starts',
        labelName: 'Video start',
        type: 'videostart',
        color: '#799AF8'
      }, {
        cssClass: 'video25pct',
        name: 'Video 25% complete events',
        labelName: 'Video 25% complete',
        type: 'video25pct',
        color: '#799AF8'
      }, {
        cssClass: 'video50pct',
        name: 'Video 50% complete events',
        labelName: 'Video 50% complete',
        type: 'video50pct',
        color: '#799AF8'
      }, {
        cssClass: 'video75pct',
        name: 'Video 75% complete events',
        labelName: 'Video 75% complete',
        type: 'video75pct',
        color: '#799AF8'
      }, {
        cssClass: 'videocomplete',
        name: 'Video Completes',
        labelName: 'Video complete',
        type: 'videocomplete',
        color: '#799AF8'
      }, {
        cssClass: 'click',
        name: 'Clicks',
        labelName: 'Click',
        type: 'click',
        color: '#A997EB'
      }, {
        cssClass: 'signup',
        name: 'Signups',
        labelName: 'Signup',
        type: 'signup',
        color: '#c8ae00'
      }, {
        cssClass: 'conversion',
        name: 'Conversions',
        labelName: 'Conversion',
        type: 'conversion',
        color: '#ff8f35'
      }, {
        cssClass: 'purchase',
        name: 'Purchases',
        labelName: 'Purchase',
        type: 'purchase',
        color: '#ff5b9d'
      }];

      const eventsService = {};

      // Helper array for sorting event types like the array above
      eventsService.eventTypeSortMap = [];
      _.each(allowedEventTypes, function(eventTypeObject, index) {
          eventsService.eventTypeSortMap[eventTypeObject.type] = index;
      });

      eventsService.eventTypeSortFunction = function(eventType) {
        return eventsService.eventTypeSortMap[ eventType ];
      };

      eventsService.getAllowedEventTypes = function() {
        return allowedEventTypes;
      };

      eventsService.getLabelName = function(eventType) {
        const event = _.find(allowedEventTypes, function(allowedEventType) {
          return allowedEventType.type == eventType;
        });
        return event.labelName;
      };

      eventsService.getUrl = function (tp, eventType) {
        if (eventType == 'impression') {
          return '<img src="https://visitanalytics.userreport.com/hit.gif?t=' + tp.cid + tp.tailcode + '">';
        } else {
          return '<img src="https://visitanalytics.userreport.com/hit.gif?t=' + tp.cid + tp.tailcode + '&event=' + eventType + '">';
        }
      };

      eventsService.generateEnrichedEventData = function(eventData) {
        const allowedEventData = [];
        angular.forEach(eventData, function(event) {
          const tmpEvent = _.find(allowedEventTypes, allowedEvent => allowedEvent.type === event.eventType);

          if (angular.isDefined(tmpEvent)) {
            event.cssClass = tmpEvent.cssClass;
            event.name = tmpEvent.name;
            event.color = tmpEvent.color;
            event.count = event.eventCount;
            event.disabled = false;
            allowedEventData.push(event);
          }
        });

        return allowedEventData;
      };

      return eventsService;
    }
})();
